module.exports = __webpack_public_path__ + "img/rule_bg.b237be72.png";